module.exports = __webpack_public_path__ + "img/nantian-propa.c51ca8d7.png";